<div class="encabezado">
  <div class="col-4 getBack">
    <a routerLink="/settings" class="getBack">
      <span><i class="icon-chevron-left"></i>{{ "forms.buttons.back" | translate }}</span>
    </a>
  </div>
  <div>
    <h5 class="titulo1">{{ "settings.mail.title" | translate }}</h5>
  </div>

  <!-- ============ SMTP MAILBOXES ============ -->
  <div class="section-header">
    <h6>{{ "settings.mail.mailboxes.title" | translate }}</h6>
    <div class="btn-izq">
      <button class="btn btn-hover" type="button" (click)="toggleSmtpForm()">
        {{ "settings.mail.mailboxes.add" | translate }} <i class="icon-plus"></i>
      </button>
    </div>
  </div>

  <!-- Mailboxes list -->
  <div *ngIf="mailboxes.length > 0" class="mailboxes-list">
    <div class="mailbox-card" *ngFor="let mailbox of mailboxes">
      <div class="mailbox-info">
        <div class="mailbox-label">
          <strong>{{ mailbox.label }}</strong>
          <span *ngIf="mailbox.is_default" class="badge bg-primary ms-2">
            {{ "settings.mail.mailboxes.default_badge" | translate }}
          </span>
        </div>
        <div class="mailbox-details">
          <span><i class="icon-mail"></i> {{ mailbox.from_address }}</span>
          <span><i class="icon-server"></i> {{ mailbox.host }}:{{ mailbox.port }}</span>
          <span *ngIf="mailbox.encryption"><i class="icon-lock"></i> {{ mailbox.encryption | uppercase }}</span>
        </div>
      </div>
      <div class="mailbox-actions">
        <i class="icon-pencil text-success icon-actions" (click)="getMailbox(mailbox.reference)"></i>
        <i class="icon-trash2 text-danger icon-actions" (click)="deleteMailbox(mailbox.reference)"></i>
      </div>
    </div>
  </div>

  <!-- Empty state -->
  <div *ngIf="mailboxes.length === 0" class="empty-state">
    <i class="icon-mail"></i>
    <p>{{ "settings.mail.mailboxes.empty" | translate }}</p>
    <p class="text-muted text-sm-hint">{{ "settings.mail.mailboxes.empty_hint" | translate }}</p>
    <button class="btn btn-hover mt-2" type="button" (click)="toggleSmtpForm()">
      {{ "settings.mail.mailboxes.add" | translate }} <i class="icon-plus"></i>
    </button>
  </div>

  <!-- ============ ROW: LOGO ============ -->
  <div class="row config-row mt-4">
    <div class="col-md-6 col-12">
      <div class="config-card">
        <div class="config-card-header" (click)="toggleSection('logo')">
          <div class="config-card-title">
            <i class="icon-image"></i>
            <span>{{ "settings.mail.logo.title" | translate }}</span>
          </div>
          <div class="config-card-status">
            <span class="badge" [ngClass]="logoConfigured ? 'bg-success' : 'bg-warning'">
              {{ (logoConfigured ? "settings.mail.configured" : "settings.mail.logo.no_logo") | translate }}
            </span>
            <i [ngClass]="sections['logo'] ? 'icon-chevron-up' : 'icon-chevron-down'"></i>
          </div>
        </div>

        <div class="config-card-summary logo-preview" *ngIf="!sections['logo'] && logoConfigured">
          <img [src]="logoUrl" alt="Logo" class="logo-img">
        </div>

        <div class="config-card-body" *ngIf="sections['logo']">
          <div class="logo-upload-area">
            <img *ngIf="logoUrl" [src]="logoUrl" alt="Logo" class="logo-img mb-3">
            <p *ngIf="!logoUrl" class="text-muted">{{ "settings.mail.logo.description" | translate }}</p>
            <div class="btn-izq justify-content-center">
              <label class="btn btn-hover clickable">
                {{ "settings.mail.logo.upload" | translate }} <i class="icon-upload"></i>
                <input type="file" accept="image/jpeg,image/png,image/gif,image/webp,image/svg+xml"
                  (change)="onLogoFileSelected($event)" hidden>
              </label>
            </div>
            <p class="text-muted mt-2 text-xs-hint">JPG, PNG, GIF, WebP, SVG — Max 4MB</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ============ TEMPLATES TABLE ============ -->
  <div class="section-header">
    <h6>{{ "settings.mail.templates.title" | translate }}</h6>
    <div class="btn-izq">
      <button class="btn btn-hover" type="button" (click)="toggleTemplateForm()">
        {{ "settings.mail.templates.add" | translate }} <i class="icon-plus"></i>
      </button>
    </div>
  </div>

  <div class="tabla">
    <div class="table-responsive-wrapper">
      <div class="table-scroll-inner">
        <table mat-table class="full-width-table" matSort [dataSource]="dataSource">

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="cabecera-tabla">
              {{ "settings.mail.templates.name" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">{{ row.name }}</td>
          </ng-container>

          <ng-container matColumnDef="subject">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="cabecera-tabla">
              {{ "settings.mail.templates.subject" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">{{ row.subject || '—' }}</td>
          </ng-container>

          <ng-container matColumnDef="roles">
            <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
              {{ "inputs.roles" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">{{ getRolesDisplay(row.roles) }}</td>
          </ng-container>

          <ng-container matColumnDef="updated_at">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="cabecera-tabla">
              {{ "inputs.updated_at" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">{{ row.updated_at | date:'dd/MM/yyyy' }}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
              {{ "inputs.actions" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
              <i class="icon-pencil text-success icon-actions" (click)="getTemplate(row.reference)"></i>
              <i class="icon-trash2 text-danger icon-actions" (click)="deleteTemplate(row.reference)"></i>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </div>
    <!-- Card layout mobile -->
    <div class="cards-mobile-wrapper">
      <div *ngFor="let row of dataSource.data" class="settings-card" (click)="getTemplate($any(row).reference)">
        <div class="card-header-row">
          <span class="card-name">{{ $any(row).name }}</span>
          <small class="text-muted">{{ $any(row).updated_at | date:'dd/MM/yyyy' }}</small>
        </div>
        <div class="card-body-content">
          <span *ngIf="$any(row).subject" class="card-detail"><i class="icon-envelope"></i> {{ $any(row).subject }}</span>
          <span class="card-detail"><i class="icon-users"></i> {{ getRolesDisplay($any(row).roles) }}</span>
        </div>
        <div class="card-footer-row">
          <div class="card-actions">
            <i class="icon-pencil text-success icon-actions" (click)="getTemplate($any(row).reference); $event.stopPropagation()"></i>
            <i class="icon-trash2 text-danger icon-actions" (click)="deleteTemplate($any(row).reference); $event.stopPropagation()"></i>
          </div>
        </div>
      </div>
    </div>
    <mat-paginator [length]="dataSource.data.length" [pageSize]="pageSize"
      [pageSizeOptions]="[10, 25, 50]" (page)="onPageChange($event)">
    </mat-paginator>
  </div>
</div>

<!-- ============ SLIDE PANEL: SMTP Form ============ -->
<div class="formulario-derecha-container" [ngClass]="{ 'mostrar-formulario': showSmtpForm }">
  <app-form-add-smtp
    *ngIf="showSmtpForm"
    [smtpData]="smtpData"
    (backButtonClick)="cerrarSmtpFormulario()"
    (addSmtp)="refrescarMailboxes()">
  </app-form-add-smtp>
</div>
<div class="overlay" *ngIf="showSmtpForm" (click)="cerrarSmtpFormulario()"></div>

<!-- ============ SLIDE PANEL: Template Form ============ -->
<div class="formulario-derecha-container" [ngClass]="{ 'mostrar-formulario': showTemplateForm }">
  <app-form-add-mail-template
    *ngIf="showTemplateForm"
    [templateData]="templateData"
    [logoUrl]="logoUrl"
    (backButtonClick)="cerrarTemplateFormulario()"
    (addTemplate)="refrescarTemplates()">
  </app-form-add-mail-template>
</div>
<div class="overlay" *ngIf="showTemplateForm" (click)="cerrarTemplateFormulario()"></div>
